import React from 'react';
import DeepResearchIndicator from './DeepResearchIndicator';
import DefaultLoadingIndicator from './indicators/DefaultLoadingIndicator';
import DocumentAnalysisIndicator from './ChatMessage/components/DocumentAnalysisIndicator';
import FileGenerationIndicator from './ChatMessage/components/FileGenerationIndicator';
import ImageGenerationSkeleton from './ChatMessage/components/ImageGenerationSkeleton';
import SuperBucketIndicator from './ChatMessage/components/SuperBucketIndicator';
import ThinkingIndicator from './indicators/ThinkingIndicator';

/**
 * Unified Loading Indicator Component
 * This component renders the appropriate loading indicator based on the indicator config
 * 
 * NOTE: SearchIndicator is NOT handled here - ChatMessage handles it directly
 * because it needs the full message object and sophisticated state management
 */
const UnifiedLoadingIndicator = ({ indicatorConfig, fallbackToDots = true, darkMode }) => {
  if (!indicatorConfig) {
    return fallbackToDots ? <DefaultLoadingIndicator dots={true} darkMode={darkMode} /> : null;
  }

  const { component, props } = indicatorConfig;

  switch (component) {
    case 'DefaultLoading':
      return <DefaultLoadingIndicator {...props} />;
      
    case 'DocumentAnalysisIndicator':
      return (
        <DocumentAnalysisIndicator 
          message={{
            analysisProgress: props.progress,
            analysisStatus: props.message
          }}
        />
      );
      
    case 'DeepResearchIndicator':
      return (
        <DeepResearchIndicator
          stage={props.stage}
          progress={props.progress}
          message={props.message}
          reasoningTokens={0}
          isVisible={true}
          darkMode={darkMode}
        />
      );
      
    case 'ImageGenerationSkeleton':
      return (
        <ImageGenerationSkeleton 
          optimalSize={props.optimalSize}
          darkMode={props.darkMode}
        />
      );
    
    case 'FileGenerationIndicator':
      return (
        <FileGenerationIndicator 
          format={props.format}
          darkMode={props.darkMode}
        />
      );
      
    case 'SuperBucketIndicator':
      return (
        <SuperBucketIndicator 
          darkMode={props.darkMode}
        />
      );
      
    case 'ThinkingIndicator':
        return (
          <ThinkingIndicator
            isThinking={props.isThinking}
            thinkingContent={props.thinkingContent}
            duration={props.duration}
          />
        );
      
    default:
      console.warn('Unknown loading indicator component:', component);
      return fallbackToDots ? <DefaultLoadingIndicator dots={true} darkMode={darkMode} /> : null;
  }
};

export default UnifiedLoadingIndicator; 